import { ValidatorFn, AbstractControl, ValidationErrors, FormGroup } from '@angular/forms';

const CUSTOMVALIDATORS_PATTERN_NUMBER:RegExp     = /^[\d\-]*$/;
const CUSTOMVALIDATORS_PATTERN_STRING:RegExp     = /^[0-9a-zA-ZñÑÁÉÍÓÚáéíóúÇçÀàÂâÃãÊêíÔôÕõÜü¡!:;,…“”´‘’°`—©®™\+\|¿?=#\$%&\/"'_\-\.\[\]\(\)\n\\<>/@–\*¨\^\~ ]*$/i;
const CUSTOMVALIDATORS_PATTERN_FILENAME:RegExp   = /^[0-9a-zA-Z_\-\(\)\.\[\] ]*$/i;
const CUSTOMVALIDATORS_PATTERN_LENGTHIMPERIAL:RegExp   = /^\d{1,2}' \d{1,2}"$|^\d{1,2}'$|^\d{1,2}"$/i;

const CUSTOMVALIDATORS_LIST_COMMONPASSWORDS      = ['Password1','Disney123@','Password1234'];

export var CustomValidators = {

    numberValidator: function(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (control.value == null || control.value == '') {
                return null;
            } else {
                const valid = CUSTOMVALIDATORS_PATTERN_NUMBER.test(control.value);
                return valid ? null : {number: {value: control.value}};
            }
        };    
    },

    invalidCharactersValidator: function(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const valid = CUSTOMVALIDATORS_PATTERN_STRING.test(control.value);
            return valid ? null : {invalidcharacters: {value: control.value}};
        };    
    },

    filenameValidator: function(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const valid = CUSTOMVALIDATORS_PATTERN_FILENAME.test(control.value);
            return valid ? null : {filename: {value: control.value}};
        };    
    },

    lengthImperialValidator: function(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if( control.value == null || control.value == '' ) return null;

            const valid = CUSTOMVALIDATORS_PATTERN_LENGTHIMPERIAL.test(control.value);
            return valid ? null : {lengthimperial: {value: control.value}};
        };    
    },

    passwordComplexityValidator: function(userLogin: string | null): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
      
            let complexityGroupCount: number = 0;
            let error = { complexity: {value: control.value} };
      
            if (control.value == "00000000000000000000" ) return null;
            
            //Password must be different from user ID
            if ( userLogin != null ) {
              if (control.value.toLowerCase() == userLogin.toLowerCase()) return error;
            }
      
            //Password must be at least 8 chars long
            if ( (control.value as string).length < 8 ) return error;

            //Password must not be equal to common password
            for( let i: number = 0 ; i < CUSTOMVALIDATORS_LIST_COMMONPASSWORDS.length ; i++ ) {
              if (control.value == CUSTOMVALIDATORS_LIST_COMMONPASSWORDS[i]) return error;
            }
      
            //Password must not contain consecutive chars
            for( let i: number = 1 ; i < control.value.length ; i++ ) {
              if (control.value.charAt(i) == control.value.charAt(i-1)) return error;
            }
      
            //Password contains number
            if ( /\d/.test(control.value) ) complexityGroupCount++;
      
            //Password contains upper case letters
            if ( /[A-Z]/.test(control.value) ) complexityGroupCount++;
      
            //Password contains lower case letters
            if ( /[a-z]/.test(control.value) ) complexityGroupCount++;
      
            //Password contains special characters
            if ( /[!@#$%^&*()_+-=[]{};':",.<>]/.test(control.value) ) complexityGroupCount++;
      
            if (complexityGroupCount < 3) return error;
      
            return null;
          };      
    },

    passwordMatchValidator: function(group: FormGroup): { [key: string]: boolean } | null {
        const newPassword = group.get('newPassword')?.value;
        const confirmPassword = group.get('confirmPassword')?.value;
        const confirmControl = group.get('confirmPassword');

        if (newPassword && confirmPassword && newPassword !== confirmPassword) {
            confirmControl?.setErrors({ passwordMismatch: true });
            return { passwordMismatch: true };
        } else {
            // Clear the mismatch error if passwords match
            if (confirmControl?.hasError('passwordMismatch')) {
                confirmControl?.setErrors(null);
            }
        }
        
        return null;
    }
}


